<template>
  <v-app>
    <!-- Navigation Bar -->
    <v-app-bar flat color="surface" border="b">
      <v-app-bar-title>
        <router-link to="/" class="d-flex align-center text-decoration-none">
          <v-icon color="primary" size="28" class="mr-2">mdi-dice-multiple</v-icon>
          <span class="text-primary font-weight-bold text-h6">Backgammon Tracker</span>
        </router-link>
      </v-app-bar-title>

      <template v-slot:append>
        <div class="d-flex align-center ga-1">
          <v-btn variant="text" to="/pricing" size="small">Pricing</v-btn>

          <template v-if="auth.isAuthenticated">
            <v-btn variant="text" to="/dashboard" size="small">Dashboard</v-btn>
            <v-btn variant="text" to="/games" size="small">Games</v-btn>
            <v-btn variant="text" to="/recorder" size="small">Record Game</v-btn>
            <v-btn v-if="canTrain" variant="text" to="/training/dice" size="small">Train AI</v-btn>

            <v-menu>
              <template v-slot:activator="{ props }">
                <v-btn icon v-bind="props" size="small">
                  <v-avatar color="primary" size="32">
                    <span class="text-caption font-weight-bold">
                      {{ userInitials }}
                    </span>
                  </v-avatar>
                </v-btn>
              </template>
              <v-list density="compact" min-width="200">
                <v-list-item>
                  <v-list-item-title class="font-weight-bold">
                    {{ auth.user?.displayName || auth.user?.username }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ auth.user?.email }}</v-list-item-subtitle>
                </v-list-item>
                <v-divider />

                <v-list-item v-if="isAdmin" to="/admin" prepend-icon="mdi-shield-crown-outline">
                  <v-list-item-title>Admin</v-list-item-title>
                </v-list-item>

                <v-list-item v-else to="/subscription" prepend-icon="mdi-credit-card-outline">
                  <v-list-item-title>Abonnement</v-list-item-title>
                </v-list-item>

                <v-divider />
                <v-list-item @click="handleLogout" prepend-icon="mdi-logout">
                  <v-list-item-title>Log out</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <template v-else>
            <v-btn variant="text" to="/login" size="small">Login</v-btn>
            <v-btn variant="flat" color="primary" to="/register" size="small">Register</v-btn>
          </template>
        </div>
      </template>
    </v-app-bar>

    <!-- Main Content -->
    <v-main>
      <router-view />
    </v-main>

    <!-- Footer — hidden on fullscreen tool pages -->
    <v-footer
      v-if="!fullscreenRoutes.includes($route.name)"
      app color="surface" border="t"
      class="text-caption text-grey pa-4 justify-center"
    >
      &copy; {{ new Date().getFullYear() }} Backgammon Tracker
    </v-footer>

    <!-- Feedback widget — hidden on fullscreen tool pages -->
    <Teleport to="body">
      <FeedbackWidget
        v-if="auth.isAuthenticated && !fullscreenRoutes.includes($route.name)"
      />
    </Teleport>
  </v-app>
</template>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "./stores/auth";
import FeedbackWidget from "./components/FeedbackWidget.vue";

const router = useRouter();
const auth = useAuthStore();

// Routes where footer and feedback widget should be hidden
const fullscreenRoutes = ['dice-labeling', 'admin-analysis-review']

const isAdmin = computed(() => auth.user?.isAdmin === true || auth.user?.isAdmin === 1);
const canTrain = computed(() => auth.user?.isAdmin || auth.user?.isModerator);

const userInitials = computed(() => {
  const name = auth.user?.displayName || auth.user?.username || "?";
  return name.substring(0, 2).toUpperCase();
});

function handleLogout() {
  auth.logout();
  router.push("/");
}
</script>